import Vue from 'vue';

export default {
  name: 'Attachments',
  props: ['propsData'],
  data: function () {
    return {
      data: {}, // { files: [ { id, name, seqId, deleted: false, file: {} } ], permissions: { add, delete, download, }, sort: false, download: function(id), mimeTypes: 'image/*,application/pdf,app/msword', multiple: false, maxFilesNumber: 3 },
      message: '',
      cntrlHelpTypes: [],
      cntrlItemHelp: '',
      files: null,
      file: '',
      showHelp: false
    }
  },
  created() {
    this.data = this.propsData;
    this.$root.$on('control_help_updated', this.init);
  },
  computed: {
    attachments: function () {
      if (this.data.sort)
        return this.data.files.filter(i => !i.deleted).sort((obj1, obj2) => obj1.seqId - obj2.seqId);
      else
        return this.data.files.filter(i => !i.deleted);
    },
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.data = this.propsData;
        this.cntrlHelpTypes = this.data.cntrlItemsHelp;
      });
    },
    openHelp(cntrlName) {
      this.cntrlItemHelp = this.getCntrlDescription(cntrlName);
      if ((this.cntrlItemHelp) && (this.cntrlItemHelp.length > 0))
        this.showHelp = true;
    },
    closeHelp() {
      this.showHelp = false;
    },
    getCntrlDescription(name) {
      var cntrlHelpType = [];
      var sCntrlTooltip = '';

      if (this.cntrlHelpTypes && this.cntrlHelpTypes.length > 0) {
        cntrlHelpType = this.cntrlHelpTypes.filter(p => p.name == name);
        sCntrlTooltip = (cntrlHelpType.length > 0) ? cntrlHelpType[0].description : '';
      }

      return sCntrlTooltip;
    },
    onSelected(e) {
      this.files = e;
      this.add(); // selectedfile added to table automatically, comment out if user should press add button
    },
    add() {
      var deleted = 0;
      for (var i = 0; i < this.data.files.length; ++i)
        if (this.data.files[i].deleted)
          deleted++;

      for (var i = 0; i < this.files.length; ++i) {
        if (this.data.files.length - deleted < this.data.maxFilesNumber) {
          var f = this.files[i];
          var newSeqId = Math.max.apply(Math, this.data.files.map(function (o) { return o.seqId; })) + 1;
          this.data.files.push({ id: -1, fileName: f.name, seqId: newSeqId, deleted: false, file: f });
        }
        else {
          this.message = 'Maximum number of attachments reached.';
          this.$alertMsg(this.messages);
          break;
        }
      }
      this.files = null;
      setTimeout(function () { this.file = '';; }.bind(this), 200);
    },
    deleteItem(item) {
      if (item) {
        if (item.id < 0) { // just added new file
          var idx = this.data.files.indexOf(item)
          if (idx >= 0)
            this.data.files.splice(idx, 1);
        }
        else
          item.deleted = true;
      }
    },
    download(id) {
      this.data.download(id);
    },
  }
}
